/**
 * Shared numeric helpers recovered from Afters build.
 */
export const clamp = (v, lo, hi) => Math.min(hi, Math.max(lo, v));
export const saturate = (v) => clamp(v, 0, 1);
export const lerp = (a, b, t) => a + (b - a) * t;
export const smoothstep01 = (t) => t * t * (3 - 2 * t);
export const remapSmooth = (edge0, edge1, v) =>
  smoothstep01(saturate((v - edge0) / (edge1 - edge0)));
export const mod = (v, m) => ((v % m) + m) % m;
export const wrapAngle = (a) => Math.atan2(Math.sin(a), Math.cos(a));
export const damp = (a, b, dt, rate) => a + (b - a) * Math.min(1, rate * dt);

export {
  clamp as E,
  saturate as D,
  lerp as ve,
  smoothstep01 as O,
  remapSmooth as k,
  mod as ye,
  wrapAngle as be,
  damp as A,
};
